import { atom, useAtom } from 'jotai'

export interface StoredMatch {
  text: string
  startIndex: number
  endIndex: number
  date: string
}

// Renderer-local draft state. These are only consumed by ReminderInput (home
// section + drawer), both in the overlay renderer, so the draft never needs to
// cross process/window boundaries — using GlobalStore here meant an IPC
// broadcast to every renderer on every keystroke. Module-level atoms still
// share the draft between the section and drawer inputs and survive the
// sidepanel closing/reopening within a session.
const reminderDraftAtom = atom<string>('')
const reminderIsMultilineAtom = atom<boolean>(false)
const reminderCurrentMatchAtom = atom<StoredMatch | null>(null)
const reminderDraftScheduledAtAtom = atom<string | null>(null)

export const useReminderDraft = () => useAtom(reminderDraftAtom)
export const useReminderIsMultiline = () => useAtom(reminderIsMultilineAtom)
export const useReminderCurrentMatch = () => useAtom(reminderCurrentMatchAtom)
export const useReminderDraftScheduledAt = () => useAtom(reminderDraftScheduledAtAtom)
